import { Sprout } from 'lucide-react'
import { useState } from 'react'

import { cn } from '@/lib/utils'

interface Props {
    src?: string
    className?: string
}

/** Square thumbnail for an agricultural material. Falls back to a sprout
 *  placeholder when there is no image OR the image fails to load. */
export function MaterialThumb({ src, className }: Props) {
    const [errored, setErrored] = useState(false)
    const box = cn('size-6 shrink-0 rounded-md', className)

    if (!src || errored) {
        return (
            <span
                className={cn(
                    box,
                    'flex items-center justify-center border bg-muted/30 text-muted-foreground',
                )}
            >
                <Sprout className="size-4 stroke-[1.5]" />
            </span>
        )
    }
    return (
        <img
            src={src}
            alt=""
            className={cn(box, 'border object-cover')}
            onError={() => setErrored(true)}
        />
    )
}
